import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=01f94164&"
import script from "./Provinces.vue?vue&type=script&lang=js&"
export * from "./Provinces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports